export default __webpack_public_path__ + "static/media/splashScreenTriangle.844debfb.png";